"use client";

import { useFetchApi } from "@/composables/useFetchApi";
import type { StrapiCollectionResponse, StrapiQuery, StrapiQueryValue, StrapiEntity } from "@/lib/strapi";
import type { SliderAttributes } from "@/services/slider";

export type UseSlidersOptions = {
  enabled?: boolean;
  query?: StrapiQuery;
  populate?: StrapiQueryValue;
  pageSize?: number;
  withBrandFilter?: boolean;
  path?: string;
  initialData?: StrapiCollectionResponse<SliderAttributes> | null;
};

export function useSliders(options?: UseSlidersOptions) {
  const query: StrapiQuery = {
    ...(options?.query ?? {}),
    filters: {
      ...(typeof options?.query?.filters === "object" && options?.query?.filters !== null
        ? (options.query.filters as Record<string, unknown>)
        : {}),
      active: { $eq: true },
    },
    sort: options?.query?.sort ?? ["order:asc", "updatedAt:desc"],
    pagination: {
      ...(typeof options?.query?.pagination === "object" && options?.query?.pagination !== null
        ? (options.query.pagination as Record<string, unknown>)
        : {}),
      pageSize: options?.pageSize ?? 10,
    },
    populate:
      options?.populate !== undefined
        ? options.populate
        : (options?.query?.populate ?? {
            image: { populate: "*" },
            mobile_image: { populate: "*" },
          }),
  };

  const state = useFetchApi<StrapiCollectionResponse<SliderAttributes>>(options?.path ?? "/sliders", {
    enabled: options?.enabled,
    query,
    withBrandFilter: options?.withBrandFilter ?? true,
    initialData: options?.initialData,
  });

  const sliders: Array<StrapiEntity<SliderAttributes>> = state.data?.data ?? [];

  return { ...state, sliders };
}
